import { render } from "./DCustomizableSelectionOptions.vue?vue&type=template&id=791c3a25&scoped=true"
import script from "./DCustomizableSelectionOptions.vue?vue&type=script&lang=js"
export * from "./DCustomizableSelectionOptions.vue?vue&type=script&lang=js"

import "./DCustomizableSelectionOptions.vue?vue&type=style&index=0&id=791c3a25&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791c3a25"]])

export default __exports__